<template>
  <div v-if="activeCard" class="relative rounded-md border border-line bg-panel/50">
    <component
      :is="target.tag"
      v-bind="target.attrs"
      class="flex w-full flex-col gap-1 rounded-md p-2 text-left text-copy"
      :class="{ 'hover:bg-tint hover:text-primary': target.tag !== 'div' }"
      @click="activeCard.isSurvey ? surveyPopover?.toggle($event) : undefined">
      <span class="flex items-center gap-1.5 pr-4">
        <img src="/img/rm-logomark.svg" alt="" class="size-3.5 shrink-0" />
        <span class="min-w-0 text-[12px] leading-4 font-semibold text-heading">{{ activeCard.title }}</span>
      </span>
      <span v-if="activeCard.description" class="text-[11.5px] leading-[15px]">
        {{ activeCard.description }}
      </span>
    </component>
    <button
      type="button"
      class="absolute top-[7px] right-[7px] flex text-faint hover:text-ink"
      title="Dismiss"
      @click="dismiss(activeCard.id)">
      <XMarkIcon class="size-3" aria-hidden="true" />
    </button>

    <Popover v-if="activeCard.isSurvey" ref="surveyPopover">
      <form class="w-60 space-y-2" @submit.prevent="surveyAnswer && submitSurvey(surveyAnswer)">
        <div class="text-[13px] font-semibold text-heading">{{ activeCard.title }}</div>
        <label
          v-for="option in activeCard.surveyOptions ?? []"
          :key="option.value"
          class="flex cursor-pointer items-center gap-2 rounded-md px-1.5 py-1 text-[13px] text-ink hover:bg-tint">
          <RadioButton v-model="surveyAnswer" name="attribution" :value="option.value" size="small" />
          {{ option.label }}
        </label>
        <Button type="submit" label="Submit" size="small" class="w-full" :disabled="!surveyAnswer" />
      </form>
    </Popover>
  </div>
</template>

<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useSidebarPromo } from '@dashboard/composables/useSidebarPromo'
import Button from 'primevue/button'
import Popover from 'primevue/popover'
import RadioButton from 'primevue/radiobutton'
import { computed, useTemplateRef } from 'vue'
import { RouterLink, useRoute } from 'vue-router'

const route = useRoute()
const { activeCard, dismiss, submitSurvey, surveyAnswer } = useSidebarPromo()
const surveyPopover = useTemplateRef<InstanceType<typeof Popover>>('surveyPopover')

const target = computed(() => {
  const card = activeCard.value
  if (card?.href) {
    return { tag: 'a', attrs: { href: card.href, target: '_blank', rel: 'noopener', title: card.title } }
  }
  if (card?.routeTo) {
    return {
      tag: RouterLink,
      attrs: {
        to: { ...card.routeTo, params: { ...card.routeTo.params, teamPid: route.params.teamPid } },
        title: card.title
      }
    }
  }
  if (card?.isSurvey) {
    return { tag: 'button', attrs: { type: 'button', title: card.title } }
  }
  return { tag: 'div', attrs: {} }
})
</script>
